// Presentation-only picker for the Calendar tab's symptom overlay
// (ITEM_REPORT_ENHANCEMENTS_PLAN.md D-IE-10/11). A native dropdown since the
// list of symptoms can be long and the modal is small.

import { Select } from "../Select.js";

export interface OverlayOption {
  key: string; // symptomFollowUpKey identity
  label: string; // display name, most-recent wording
  lastAt: string; // ISO of the most recent event, for the sort + option hint
}

interface Props {
  options: OverlayOption[]; // pre-sorted, own-item identity already excluded
  value: string | null; // selected key, null = none
  onChange: (key: string | null) => void;
  loading?: boolean;
}

export function SymptomOverlayPicker({ options, value, onChange, loading }: Props) {
  if (!loading && options.length === 0) return null;

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-gray-500 dark:text-gray-400">Compare with symptom:</span>
      <Select
        variant="dense"
        value={loading ? "" : (value ?? "")}
        disabled={loading}
        onChange={(e) => onChange(e.target.value || null)}
        className="min-h-[44px] dark:bg-gray-900 sm:min-h-0 sm:py-1.5"
      >
        {loading ? (
          <option value="">Loading…</option>
        ) : (
          <>
            <option value="">— none —</option>
            {options.map((o) => (
              <option key={o.key} value={o.key}>
                {o.label}
              </option>
            ))}
          </>
        )}
      </Select>
    </div>
  );
}
